import { forwardRef } from "react";
import { Input, InputRef } from "antd";

import { useDebounceInput } from "@/shared/hooks/use-debounce-input";

export interface InputSearchProps extends React.ComponentProps<typeof Input.Search> {
	delay?: number;
	value: string;
	setSearchValue: (value: string) => void;
}

export const UISearchInput = forwardRef<InputRef, InputSearchProps>(
	({ value, delay, setSearchValue, ...searchProps }, ref) => {
		const { localValue, setLocalValue } = useDebounceInput({
			delay,
			value,
			onDebouncedValue: setSearchValue,
		});

		return (
			<Input.Search
				onChange={(e) => setLocalValue(e.target.value)}
				placeholder="Search"
				value={localValue}
				size="small"
				allowClear
				ref={ref}
				{...searchProps}
			/>
		);
	}
);
